import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EformService } from 'app/e-form/service/eform.service';
import { TaskAttribute } from 'app/e-signature/create-task/create-task.type';
import { Subject } from 'rxjs';

@Component({
   selector: 'app-field-builder',
   templateUrl: './field-builder.component.html',
   styleUrls: ['./field-builder.component.scss']
})
export class FieldBuilderComponent implements OnInit, AfterViewInit {
   @Input() field: any;
   @Input() form: any;
   @Input() option: any;
   @Input() checkValidate: boolean;
   @Input() classes: any;
   @Input() fieldName: any;
   @Input() imageNoSignaturePreview: any;
   @Input() imageSignaturePreview: any;
   @Input() imageInitializePreview: any;
   @Input() fNameValue: any;
   @Input() lNameValue: any;
   @Input() isFormName: any;
   @Input() isPreview: boolean;
   @Input() isViewOnly: boolean;
   @Input() isCreateFile: boolean;
   @Input() taskAttribute: TaskAttribute;
   @Input() isSignDoc: boolean;
   @Input() isStartFlow: boolean;
   @Input() sectionKey: any;
   @Input() sectionList: any;
   @Input() haveSign: boolean = false;

   @Output() selectSig = new EventEmitter<any>();
   @Output() showSignTool = new EventEmitter<any>();
   @Output() signAllForm = new EventEmitter();
   lang: string;
   labelName: string;
   placeholder: string;
   choices = [];
   objChoice: any;
   checkHaveToSignItem: boolean = false;
   constructor(private service:EformService, private cdr: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.lang = this.service.selectedLanguage;
      if (this.field.placeholder !== undefined) {
         this.setPlaceholder();
      }
      this.setChoice();
      this.labelName = this.setLabelName(this.field.labelName);
      if (this.sectionList && this.sectionKey){
         this.sectionList.forEach(item => {
            if (item.key === this.sectionKey) {
               this.checkHaveToSignItem = item.isSign;
            }
         });
      }
      if (this.checkHaveToSignItem) {
         this.haveSign = true;
      }
   }

   ngAfterViewInit(): void {

      if (this.isViewOnly || this.service.isNotCompleteAllSign) {
         if (this.field.fieldType !== 'f-signature') {
            if (this.field.fieldType === 'f-address') {
               this.form.controls['address1-' + this.field.fieldName]?.disable();
               this.form.controls['address2-' + this.field.fieldName]?.disable();
               this.form.controls['district-' + this.field.fieldName]?.disable();
               this.form.controls['province-' + this.field.fieldName]?.disable();
               this.form.controls['subDistrict-' + this.field.fieldName]?.disable();
               this.form.controls['zipCode-' + this.field.fieldName]?.disable();
               this.form.controls['city-' + this.field.fieldName]?.disable();
               this.form.controls['state-' + this.field.fieldName]?.disable();
               this.form.controls['postal-' + this.field.fieldName]?.disable();
               this.form.controls['country-' + this.field.fieldName]?.disable();
            } else if (this.field.fieldType === 'f-name') {
               this.form.controls['initial' + this.field.fieldName]?.disable();
               this.form.controls['middle' + this.field.fieldName]?.disable();
               this.form.controls['name' + this.field.fieldName]?.disable();
               this.form.controls['surname' + this.field.fieldName]?.disable();
               this.form.controls['titleOther' + this.field.fieldName]?.disable();
               this.form.controls['title' + this.field.fieldName]?.disable();
            } else if (this.field.fieldType === 'f-radio') {
               this.form.controls[this.field.fieldName]?.disable();
            } else if (this.form.controls[this.field.fieldName]?.value) {
               this.form.controls[this.field.fieldName]?.disable();
            }
            this.form.controls[this.field.fieldName]?.disable();
         }
      }

      if (this.checkHaveToSignItem) {
         if (this.field.fieldType !== 'f-signature') {
            if (this.field.fieldType === 'f-address') {
               this.form.controls['address1-' + this.field.fieldName]?.enable();
               this.form.controls['address2-' + this.field.fieldName]?.enable();
               this.form.controls['district-' + this.field.fieldName]?.enable();
               this.form.controls['province-' + this.field.fieldName]?.enable();
               this.form.controls['subDistrict-' + this.field.fieldName]?.enable();
               this.form.controls['zipCode-' + this.field.fieldName]?.enable();
               this.form.controls['city-' + this.field.fieldName]?.enable();
               this.form.controls['state-' + this.field.fieldName]?.enable();
               this.form.controls['postal-' + this.field.fieldName]?.enable();
               this.form.controls['country-' + this.field.fieldName]?.enable();
            } else if (this.field.fieldType === 'f-name') {
               this.form.controls['initial' + this.field.fieldName]?.enable();
               this.form.controls['middle' + this.field.fieldName]?.enable();
               this.form.controls['name' + this.field.fieldName]?.enable();
               this.form.controls['surname' + this.field.fieldName]?.enable();
               this.form.controls['titleOther' + this.field.fieldName]?.enable();
               this.form.controls['title' + this.field.fieldName]?.enable();
            } else if (this.field.fieldType === 'f-radio') {
               this.form.controls[this.field.fieldName]?.enable();
            } else if (this.form.controls[this.field.fieldName]?.value) {
               this.form.controls[this.field.fieldName]?.enable();
            }
            this.form.controls[this.field.fieldName]?.enable();
         }
         this.cdr.detectChanges();

      }
      if (this.isSignDoc && this.form.get(this.field.fieldName) && !this.checkHaveToSignItem) {
         this.form.get(this.field.fieldName).clearValidators();
         this.form.get(this.field.fieldName).updateValueAndValidity();
         this.cdr.detectChanges();
      }
   }

   setLabelName(addressLabel) {
      const { en, th, cn } = addressLabel;
      switch (this.lang) {
         case 'en':
           return en !== undefined && en !== '' ? en : th || null;
         case 'th':
           return th !== undefined && th !== '' ? th : en || null;
         case 'cn':
           return cn !== undefined && cn !== '' ? cn : th || en || null;
         default:
           return th !== undefined && th !== '' ? th : en || null;
       }
   }

   setPlaceholder() {
      if (this.field.fieldType === 'f-email') {
         this.setPlaceHolderDefaultValue('example@email.com');
      } else if (this.field.fieldType === 'f-website') {
         this.setPlaceHolderDefaultValue('http://www.abc.com');
      } else {
         this.setPlaceHolderDefaultValue('');
      }
   }

   setPlaceHolderDefaultValue(defaultValue) {
      const { en, th, cn } = this.field.placeholder;
      switch (this.lang) {
         case 'th':
            this.placeholder = th !== undefined && th !== '' ? th : en || defaultValue;
            break;
         case 'cn':
            this.placeholder = cn !== undefined && cn !== '' ? cn : th || en || defaultValue;
            break;
         default:
            this.placeholder = en !== undefined && en !== '' ? en : th || defaultValue;
      }
   }

   setChoice() {
      this.objChoice = (this.field.choiceOption === 0) ? this.field.choices : this.field.choiceTmp;
      if (this.objChoice !== undefined) {
         for (let i = 0; i < this.objChoice.length; i++) {
            if (this.field.type === 'dropdown') {
               this.insertDataChoice(this.objChoice[i]);
            } else {
               if (!this.objChoice[i].isPrompt) {
                  this.insertDataChoice(this.objChoice[i]);
               }
            }
         }
      }
   }

   insertDataChoice(choice) {
      switch(this.lang) {
         case 'th' :{
            this.choices.push({label: choice.label.th, value: choice.value});
            break;
         }
         case 'cn': {
            this.choices.push({label: choice.label.cn, value: choice.value});
            break;
         }
         default: {
            this.choices.push({label: choice.label.en, value: choice.value});
         }
      }
   }

   selectSignature(event) {
      let fieldName, taskContactId;
      fieldName = event.fieldName;
      taskContactId = event.taskContactId;
      this.selectSig.emit({fieldName, taskContactId});
   }

   onshowSignTool(flag) {
      this.showSignTool.emit(flag);
   }

   autoSignAllForm(): void {
      this.signAllForm.emit();
   }
}
